import { render, staticRenderFns } from "./SalidasList.vue?vue&type=template&id=ce63837e&"
import script from "./SalidasList.vue?vue&type=script&lang=js&"
export * from "./SalidasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports